import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { AlertTriangle, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function ImpersonationBanner() {
  const { impersonation, refresh } = useAuth();
  const navigate = useNavigate();
  if (!impersonation || !impersonation.active) return null;

  const stop = async () => {
    try {
      await api.post("/platform/stop-impersonate");
      toast.success("Impersonation beendet");
      await refresh();
      navigate("/platform/tenants");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Fehler");
    }
  };

  return (
    <div className="sticky top-0 z-50 bg-red-600 text-white px-4 py-2 flex items-center justify-between gap-3 text-sm" data-testid="impersonation-banner">
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="truncate">
          <strong>Impersonation aktiv</strong> · Modus: <strong>{impersonation.mode === "read_only" ? "Read-Only" : "Full Access"}</strong>
          <span className="hidden sm:inline"> · als {impersonation.real_email}</span>
        </span>
      </div>
      <Button size="sm" variant="secondary" onClick={stop} className="bg-white text-red-700 hover:bg-red-50 shrink-0" data-testid="impersonation-stop-btn">
        <LogOut className="h-3.5 w-3.5 mr-1.5" /> Beenden
      </Button>
    </div>
  );
}
